import { Box, BoxProps, Typography, TypographyProps } from "@mui/material";
import { HTMLAttributes } from "react";

type ResultNotFoundProps = BoxProps & {
  title?: string;
  message?: string;
  banner?: string;
  titleProps?: TypographyProps;
  messageProps?: TypographyProps;
  bannerProps?: HTMLAttributes<HTMLImageElement>;
};

export default function ResultNotFound({
  title,
  message,
  banner,
  titleProps,
  messageProps,
  bannerProps,
  sx,
  ...restProps
}: ResultNotFoundProps) {
  return (
    <Box
      {...restProps}
      sx={{
        color: "#a6a6a6",
        display: "flex",
        flexDirection: "column",
        gap: 12,
        alignItems: "center",
        justifyContent: "center",
        ...sx
      }}
    >
      {banner && (
        <Box>
          <img src={banner} alt='result not found' height={96} width={96} {...bannerProps} />
        </Box>
      )}

      <Typography align='center' variant='h6' fontWeight='500' {...titleProps}>
        {titleProps?.children || "Oops! There's nothing here."}
      </Typography>
      <Typography align='center' variant='subtitle2' maxWidth='18rem' mx='auto' {...messageProps}>
        {messageProps?.children || "There is nothing to view here to right now, please add new item or adjust filters."}
      </Typography>
    </Box>
  );
}
